import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const viewsApi = createApi({
  reducerPath: 'viewsApi',
  baseQuery: baseQueryWithReauth,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getViews: builder.query({
      query: (params) => {
        return {
          url: 'views',
          params: params,
        };
      },
      providesTags: ['Views'],
    }),

    createView: builder.mutation({
      query: ( view ) => ({
        url: `views`,
        method: 'POST',
        body: view,
      }),
      invalidatesTags: ['Views'],
      transformResponse: (response) => {
        return response;
      },
    }),
    updateView: builder.mutation({
      query: ( view ) => ({
        url: `views/${view._id}`,
        method: 'PATCH',
        body: view,
      }),
      invalidatesTags: ['Views'],
      transformResponse: (response) => {
        return response;
      },
    }),
    deleteView: builder.mutation({
      query: ( view ) => ({
        url: `views/${view._id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Views'],
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const {
  useGetViewsQuery,
  useCreateViewMutation,
  useUpdateViewMutation,
  useDeleteViewMutation
} = viewsApi;
